import "./sponsorTable.scss";
import { DataGrid } from "@mui/x-data-grid";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import {
  Button,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  CircularProgress, // Import CircularProgress for loading indicator
} from "@mui/material";
import { Add, Delete } from "@mui/icons-material";
import { useSelector } from "react-redux";

const SponsorTable = () => {
  let userId = useSelector((state) => state.user.userId);
  const adminType = useSelector((state) => state.user.adminType);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();

  // States
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true); // Loading state
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedSponsor, setSelectedSponsor] = useState(null);

  if (adminType === "sAdmin") {
    userId = "1";
  }

  // Fetch all Sponsors
  useEffect(() => {
    const fetchSponsor = async () => {
      setLoading(true); // Set loading state to true before fetching
      try {
        const res = await axios.get(
          `${BASE_URL}/api/sponsor/findAllSponsor/${userId}`,
        );
        setData(res.data);
      } catch (err) {
        console.error("Error fetching sponsors:", err);
      }
      setLoading(false); // Set loading state to false after data is fetched
    };
    fetchSponsor();
  }, [userId, BASE_URL]);

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(
        `${BASE_URL}/api/sponsor/deleteSponsor/${id}`,
      );
      if (response.status === 200) {
        setData(data.filter((item) => item._id !== id));
      }
    } catch (err) {
      console.error("Error deleting sponsor:", err);
    }
  };

  // const handleUpdate = (sponsorData) => {
  //   navigate("/sponsor/newSponsor", { state: { sponsor: sponsorData } }); // Pass user data to Sponsor
  // };

  const sponsorListColumns = [
    { field: "_id", headerName: "ID", width: 70 },
    {
      field: "fullName",
      headerName: "Full Name",
      width: 230,
      renderCell: (params) => {
        return (
          <div className="cellWithImg">
            <img className="cellImg" src={params.row.image?.url} alt="avatar" />
            {params.row.fullName}
          </div>
        );
      },
    },
    {
      field: "fatherName",
      headerName: "Father",
      width: 120,
    },
    {
      field: "motherName",
      headerName: "Mother",
      width: 120,
    },
    {
      field: "occupation",
      headerName: "Occupation",
      width: 120,
    },
    {
      field: "phoneNumber",
      headerName: "Phone",
      width: 120,
    },
    {
      field: "address",
      headerName: "Address",
      width: 120,
    },
  ];

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <IconButton color="primary" aria-label="addButton">
              <Link to="/sponsor/newSponsor">
                <Add />
              </Link>
            </IconButton>

            {/* <IconButton
              onClick={() => handleUpdate(params.row)}
              color="primary"
              aria-label="update"
            >
              <Edit />
            </IconButton> */}
            <IconButton
              onClick={() => {
                setSelectedSponsor(params.row);
                setOpenDialog(true);
              }}
              color="error"
              aria-label="delete"
            >
              <Delete />
            </IconButton>
          </div>
        );
      },
    },
  ];

  const handleDialogClose = () => {
    setOpenDialog(false);
    setSelectedSponsor(null);
  };

  const handleConfirmDelete = async () => {
    if (selectedSponsor) {
      await handleDelete(selectedSponsor._id);
      setOpenDialog(false);
    }
  };

  return (
    <div className="datatable">
      <div className="datatableTitle">
        <Typography variant="h5" gutterBottom>
          List Of Sponsors
        </Typography>
        <Link to="/sponsor/newSponsor">
          <Button variant="contained" color="primary">
            Add Sponsor
          </Button>
        </Link>
      </div>
      <Grid container justifyContent="center">
        {loading ? ( // Show loading indicator while fetching
          <CircularProgress size={50} />
        ) : (
          <DataGrid
            className="datagrid"
            rows={data}
            columns={sponsorListColumns.concat(actionColumn)}
            pageSize={5}
            rowsPerPageOptions={[5]}
            checkboxSelection
            getRowId={(row) => row._id}
          />
        )}
      </Grid>

      <Dialog open={openDialog} onClose={handleDialogClose}>
        <DialogTitle>Delete Confirmation</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to delete this Sponsor?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="error">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default SponsorTable;
